// import React from "react";
import { createRoot } from 'react-dom/client';
import {
  createBrowserRouter,
  RouterProvider,
  // Route,
  Link,
} from 'react-router-dom';

import './App.css';

import Header from './components/Header';
import Landing from './components/Landing';
// import Pricing from './components/Pricing';
// import Developer from './components/Developer';
// import Guide from './components/Guide';
// import AboutUs from './components/AboutUs';
// import Footer from './components/Footer';
// import LaunchApp from './components/LaunchApp';

// import Dashboard from './components/farmers/Dashboard';
// import CreateHub from './components/farmers/CreateHub';
// import AddCrop from './components/farmers/AddCrop';
// import SideBar from './components/farmers/SideBar';

// FARMERS

const router = createBrowserRouter([
  { path: '', element: <Landing /> },

  {
    path: '/dashboard/',
    children: [
      // { path: '', element: <Dashboard /> },
      // { path: 'create-hub', element: <CreateHub /> },
      // { path: 'add-crop', element: <AddCrop /> },
    ],
  },
]);

function App() {
  return (
    <>
      <RouterProvider router={router} />
    </>
  );
}

export default App;
